/**
 * Store for the public API Bearer identifier (public key when available, else tenant slug).
 * Set by PublicApiIdentifierProvider; read by the API client for all /publicapi requests.
 */
let publicApiIdentifier: string | null = null;

export const getPublicApiIdentifier = (): string | null => publicApiIdentifier;

export const setPublicApiIdentifier = ( value: string | null ): void => {
  publicApiIdentifier = value;
};
